// Add a comment at the top of the file to force it to be rebuilt
// React-refresh symlink test
// This file serves as the entry point for Create React App
// It simply requires the index.tsx file
require("./index.tsx");